type PdfViewerProps = {
    src: string;
    title: string;
};

export const PdfViewer = ({ src, title }: PdfViewerProps) => (
    <iframe src={src} title={title} className="h-[75vh] w-full border-0" />
);
